import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "s20" }
const _hoisted_3 = { class: "table separator skin3 selection rounded" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  colspan: "9",
  class: "text-center py-5"
}
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "selection-item bg-color-1000" }
const _hoisted_9 = {
  class: "square-xxl rounded-15 ml-3 px-3 py-3",
  style: {"background-color":"rgb(var(--color-white-rgb), 1)"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  class: "bg-color-1000",
  style: {"width":"15%"}
}
const _hoisted_12 = { class: "text-xl font-semibold mb-2 text-white" }
const _hoisted_13 = {
  class: "font-semibold bg-color-800 pl-6",
  style: {"width":"10%"}
}
const _hoisted_14 = { class: "text-white" }
const _hoisted_15 = {
  class: "font-semibold",
  style: {"width":"10%"}
}
const _hoisted_16 = { class: "tag-state success stroke" }
const _hoisted_17 = {
  class: "text-3xl",
  style: {"width":"10%"}
}
const _hoisted_18 = {
  class: "h-40 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_19 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_20 = { class: "text-2xl position-absolute px-7" }

import { computed, onMounted, reactive, ref, toRaw } from 'vue';
    import axios from 'axios';
import { formatAmount } from '@/utils';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'FinancePrelevementsListView',
  setup(__props) {

    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);
    const queryParams = reactive({
        pageNumber: 1,
        sortDir: 'ASC',
        sortColumn: 'nom',
        sortOption: 'nom_asc',
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const SORT_OPTIONS = [
        { value: 'nom_asc', label: 'Nom (ASC)', sort_column: 'nom', sort_direction: 'ASC' },
        { value: 'nom_desc', label: 'Nom (DESC)', sort_column: 'nom', sort_direction: 'DESC' },
        { value: 'created_at_asc', label: 'Date (ASC)', sort_column: 'created_at', sort_direction: 'ASC' },
        { value: 'created_at_desc', label: 'Date (DESC)', sort_column: 'created_at', sort_direction: 'DESC' },
    ];

    onMounted(() => {
        doListItems();
    });

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/finance/prelevements/list_collectivites?${queryString}`);
            itemsList.value = httpResponse.data.data;
            pagination.total = httpResponse.data.total;
            pagination.per_page = httpResponse.data.per_page;
            pagination.last_page = httpResponse.data.last_page;
        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    function onPaginate(pageNumber: number) {
        queryParams.pageNumber = pageNumber;
        doListItems();
    }
    function getPrelevementPercentage(collectivite: any) {
        if (!collectivite.prelevement) {
            return 0;
        }
        return collectivite.prelevement.montant_prelevement && collectivite.prelevement.montant_prelevement_expected
            ? Math.min(100, (collectivite.prelevement.montant_prelevement / collectivite.prelevement.montant_prelevement_expected) * 100).toFixed(0)
            : 0;
    }


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"widget shadow-100 s20 pb-2\"><div class=\"container-full-2 s20 my-5\"><div class=\"s7\"><h4 class=\"font-semibold mt-4\">Prélèvements <span class=\"text-sm text-grey-500\">(recent)</span></h4></div><div class=\"s13 flex justify-content-right\"><div class=\"form-field-floating default sm s4_mobile ml-3\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Période</option><option value=\"\">Ordre Décroissant</option><option value=\"\">Ordre Croissant</option><option value=\"\">De A - Z</option><option value=\"\">De Z - A</option></select></div><div class=\"form-field-floating default sm s4_mobile ml-3\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\">Trier</option><option value=\"\" selected>Ordre Décroissant</option><option value=\"\">Ordre Croissant</option><option value=\"\">De A - Z</option><option value=\"\">De Z - A</option></select></div><button class=\"btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter\"><img src=\"/icons/icon-filter.svg\" class=\"btn-icon\" alt=\"\"><span>Options</span></button></div><div class=\"clear-both\"></div><div class=\"filter-set-area\"><div class=\"grid-filter6 mt-4 mb-0\"><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date1\" id=\"date1\" placeholder=\"\"><label for=\"date1\">Date de création &lt;=</label></div><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date2\" id=\"date2\" placeholder=\"\"><label for=\"date2\">Date de création &gt;=</label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-excel.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter Excel</span></button><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-pdf.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter PDF</span></button></div></div></div></div>", 1)),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("label", {
                  class: "btn-circle",
                  for: "check-list1"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    name: "check-list",
                    id: "check-list1"
                  })
                ])
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                })
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Période")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Date / Etat")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Membres")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Prélèvement")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Décaissement")
              ])
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                  _createElementVNode("td", _hoisted_5, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("div", { class: "loader dark" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (itemsList.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("td", {
                      colspan: "9",
                      class: "text-center py-5"
                    }, " Aucune fichier de prélèvement trouvée. ", -1)
                  ]))]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(itemsList.value, (collectivite, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "text-grey-700 over-effect",
                      key: 'collectivite_' + index
                    }, [
                      _createElementVNode("td", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("img", {
                            src: '/assets/logos/logo' + ((index % 5) + 1) + '.svg',
                            width: "100%"
                          }, null, 8, _hoisted_10)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_11, [
                        _createVNode(_component_router_link, {
                          to: '/app/finance/prelevements/' + collectivite.id
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_12, [
                              _createTextVNode(_toDisplayString(collectivite.nom) + " ", 1),
                              _cache[2] || (_cache[2] = _createElementVNode("br", { class: "mb-3" }, null, -1)),
                              _cache[3] || (_cache[3] = _createTextVNode(" C788PMKJ   ", -1)),
                              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("h4", _hoisted_14, _toDisplayString(collectivite.prelevement ? collectivite.prelevement.periode_prelevement_formatted : '-'), 1)
                      ]),
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(collectivite.prelevement ? collectivite.prelevement.status_prelevement_label : '-'), 1),
                        _cache[5] || (_cache[5] = _createElementVNode("br", { class: "mb-5" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(collectivite.prelevement ? collectivite.prelevement.created_at_formatted : '-'), 1)
                      ]),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(collectivite.users_count), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(getPrelevementPercentage(collectivite)) + "%", 1),
                          _createElementVNode("div", {
                            class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl bg-pop-yellow",
                            style: _normalizeStyle({'width': getPrelevementPercentage(collectivite) + '%'})
                          }, [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(collectivite.prelevement != null ? _unref(formatAmount)(collectivite.prelevement.montant_prelevement) + ' F /' + _unref(formatAmount)(collectivite.prelevement.montant_prelevement_expected) + ' F' : '-'), 1)
                          ], 4)
                        ])
                      ]),
                      _cache[6] || (_cache[6] = _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: "h-60 rounded-100 position-relative",
                          style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
                        }, [
                          _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right text-white" }, "100%"),
                          _createElementVNode("div", {
                            class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl bg-color-1000",
                            style: {"width":"100%"}
                          }, [
                            _createElementVNode("div", { class: "text-3xl position-absolute text-white px-7" }, "1 900 000 F / 1 900 000 F")
                          ])
                        ])
                      ], -1))
                    ]))
                  }), 128))
          ])
        ])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
  ]))
}
}

})